import { useEffect, useState } from "react";

export default function useGetClinicCode(): string {
  const [clinicCode, setClinicCode] = useState<string>("");

  const getElementClinicIds = (): string => {
    const element = document?.getElementById("df-chat-details");
    const foundClinicCode = element?.getAttribute("clinic-code");

    return foundClinicCode ? foundClinicCode : "df_clinic";
  };

  useEffect(() => {
    if (!clinicCode) {
      setClinicCode(getElementClinicIds());
    }
  }, [clinicCode]);

  return clinicCode;
}
